(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-add-items"] && !window.DesignMode) return;
  try {
    
class PackSelector {
  constructor() {
    this.section = document.querySelector('[data-section-type="pack-selection"]');
    if (!this.section) return;

    this.packOptions = this.section.querySelectorAll('.pack-option');
    this.quantityInput = this.section.querySelector('.quantity-selector__input');
    this.addToCartButton = this.section.querySelector('[data-add-to-cart]');
    this.priceDisplay = this.addToCartButton.querySelector('.add-to-bag__price');
    
    this.init();
  }

  init() {
    // Pack selection
    this.packOptions.forEach(option => {
      option.addEventListener('click', () => this.selectPack(option));
    });

    // Quantity controls
    this.section.querySelectorAll('[data-action]').forEach(button => {
      button.addEventListener('click', (e) => {
        const action = e.target.dataset.action;
        if (action === 'increase') this.updateQuantity(1);
        if (action === 'decrease') this.updateQuantity(-1);
      });
    });

    // Add to cart
    this.addToCartButton.addEventListener('click', () => this.addToCart());
  }

  selectPack(selectedOption) {
    this.packOptions.forEach(option => {
      option.classList.remove('pack-option--selected');
    });
    selectedOption.classList.add('pack-option--selected');
    
    const price = selectedOption.dataset.productPrice;
    this.updatePrice(price);
  }

  updateQuantity(change) {
    const currentVal = parseInt(this.quantityInput.value) || 1;
    const newVal = Math.max(1, currentVal + change);
    this.quantityInput.value = newVal;
    
    const selectedOption = this.section.querySelector('.pack-option--selected');
    if (selectedOption) {
      const price = selectedOption.dataset.productPrice;
      this.updatePrice(price, newVal);
    }
  }

  updatePrice(basePrice, quantity = 1) {
    const total = (parseFloat(basePrice) * quantity).toFixed(2);
    this.priceDisplay.textContent = `$${total}`;
  }

  async addToCart() {
    const selectedPack = this.section.querySelector('.pack-option--selected');
    if (!selectedPack) return;

    const variantId = selectedPack.dataset.variantId;
    const quantity = parseInt(this.quantityInput.value) || 1;

    selectedPack.classList.add('loading');
    this.addToCartButton.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });

      if (response.ok) {
        // For Dawn theme cart drawer
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        // Open cart drawer if it exists, otherwise redirect to cart page
        const cartDrawerToggle = document.querySelector('cart-drawer');
        if (cartDrawerToggle) {
          cartDrawerToggle.open();
        } else {
          window.location.href = '/cart';
        }
      }
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      selectedPack.classList.remove('loading');
      this.addToCartButton.disabled = false;
    }
  }
}

// Initialize the pack selector
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new PackSelector());
} else {
  new PackSelector();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-2"] && !window.DesignMode) return;
  try {
    
   // js for section four 
        
        let btn1 = document.getElementById('btn1');
        let btn2 = document.getElementById('btn2');
        let btn3 = document.getElementById('btn3');
        let btn4 = document.getElementById('btn4');
        let btn5 = document.getElementById('btn5');
        let btn6 = document.getElementById('btn6');
        // let activeBtn = document.querySelector(".active-btn")

        let firstSection = document.getElementById('first-section'); 
        let secondSection = document.getElementById('second-section'); 
        let thirdSection = document.getElementById('third-section'); 
        let fourSection = document.getElementById('four-section'); 
        let fiveSection = document.getElementById('five-section'); 

         btn1.onclick = ()=>{
             firstSection.style.display = "block";
             secondSection.style.display = "none";
             thirdSection.style.display = "none";
             fourSection.style.display = "none";
             fiveSection.style.display = "none";
            //  if(firstSection.style.display = "block"){
            //     btn1.classList.add('active-btn')
            //  }
   
         }

         btn2.onclick = ()=>{
             firstSection.style.display = "none";
             secondSection.style.display = "block";
             thirdSection.style.display = "none";
             fourSection.style.display = "none";
             fiveSection.style.display = "none";
         }
         btn3.onclick = ()=>{
             firstSection.style.display = "none";
             secondSection.style.display = "none";
             thirdSection.style.display = "block";
             fourSection.style.display = "none";
             fiveSection.style.display = "none";
         }

         btn4.onclick = ()=>{
             firstSection.style.display = "none";
             secondSection.style.display = "none";
             thirdSection.style.display = "none";
             fourSection.style.display = " block";
             fiveSection.style.display = "none";
         }

         btn5.onclick = ()=>{
             firstSection.style.display = "none";
             secondSection.style.display = "none";
             thirdSection.style.display = "none";
             fourSection.style.display = "none";
             fiveSection.style.display = "block";
         }

         btn6.onclick = ()=>{
             firstSection.style.display = "block";
             secondSection.style.display = "block";
             thirdSection.style.display = "block";
             fourSection.style.display = "block";
             fiveSection.style.display = "block";
         }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-4"] && !window.DesignMode) return;
  try {
    
   
    
        var swiper = new Swiper(".mySwiper", {
            slidesPerView: 3,
            slidesPerGroup: 3,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

  } catch(e) { console.error(e); }
})();
})();
